import { useState, useEffect } from 'react';
import { checkHealth } from '../services/healthCheck';

export const useHealthCheck = () => {
  const [isHealthy, setIsHealthy] = useState<boolean | null>(null);
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    
    const checkServerHealth = async () => {
      const healthy = await checkHealth();
      setIsHealthy(healthy);
      
      if (!healthy) {
        timeoutId = setTimeout(() => {
          setShowWarning(true);
        }, 5000);
      }
    };

    checkServerHealth();

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, []);

  return { isHealthy, showWarning, setShowWarning };
};